import React from 'react';
import './CartItem.scss';

const cartCondition = data => {
    return data.classification === 'services' || data.classification === 'loyalty_services' || data.classification === 'contact_lens' || data.classification === 'contact_lens_solution';
};

const viewPowerstoggle = index => {
    document.querySelector(`.view-power-toggle${index} .view-power-lens`).classList.toggle('hide');
    document.querySelector(`.view-power-toggle${index} .toggle-arrow`).classList.toggle('toggle-arrow-view');
};

const CartItem = props => {
    const { data, decrementItem, incrementItem, deleteCartItem, index } = props;
    const smlImgPattern = /(thumbnail\/628x301\/)/gm;
    const smlProductImg = 'thumbnail/100x100/';
    return (
        <div className="row-fluid cart-item">
            <i onClick={() => { deleteCartItem(data.id, data.productId); }} className="cart-item_remove-icon"></i>
            <div className="cart-item_container blck-imgq">
                <div className="fs12 text-center">{data.name.substring(0, 39)}...</div>
                <span className="cart-item_container_thumb">
                    <a href={data.productUrl} target="_blank" rel="noopener noreferrer">
                        {
                            data.thumbnail ? <img className="max-width-100" src={data.thumbnail.replace(smlImgPattern, smlProductImg)} alt={data.name} /> : <img src={data.thumbnail} alt={data.name} />
                        }
                    </a>
                </span>
                <div className="cart-item_container_qty-block">
                    <span className="cart-item_container_qty-block_title">Qty</span>
                    <span className={cartCondition(data) ? 'blck-qty margin-t21' : 'blck-qty'}>
                        {cartCondition(data) ? '' : <i className="icon-qtyMinus" onClick={() => { decrementItem(data.id, data.productId); }}></i>}
                        <input readOnly className="qty-value" type="text" value={data.quantity} />
                        {cartCondition(data) ? '' : <i className="icon- plus" style={{ pointerEvents: data.availableQuantity === 1 && 'none', opacity: data.availableQuantity === 1 && '0.2' }} onClick={() => { incrementItem(data.id); }}></i>}
                    </span>
                </div>
            </div>
            <div className="cart-item_amount">
                <div className="crt-frm-prce">
                    {data.classification !== 'eyeframe' ? <div>PRODUCT PRICE</div> : <div>FRAME PRICE</div>}
                    <span className="off-price color-yellow">
                        {
                            data.catalogPrices[0].value > data.catalogPrices[1].value
                            && (
                                <span>
                                    <s>
                                    <i className="fa fa-rupee"></i>{data.catalogPrices[0].value * data.quantity}
                                    </s>
                                    <br />
                                    <i className="fa fa-rupee"></i>{data.catalogPrices[1].value * data.quantity}
                                </span>
                            )
                        }
                        {
                            data.catalogPrices[0].value === data.catalogPrices[1].value && typeof data.catalogPrices[2] !== 'undefined'
                            && (
                                <span><i className="fa fa-rupee"></i>{data.catalogPrices[1].value * data.quantity}</span>
                            )
                        }
                        {
                            data.catalogPrices[0].value === data.catalogPrices[1].value && typeof data.catalogPrices[2] === 'undefined'
                            && (
                                <span>
                                    <i className="fa fa-rupee"></i>{data.catalogPrices[1].value * data.quantity}
                                </span>
                            )
                        }
                    </span>
                </div>
                {data.classification !== undefined && data.classification === 'contact_lens'
                    && (
                        <div className={`crt-lns-prce view-power-toggle${index}`}>
                            <div className="text-center toggle-arrow" onClick={() => { viewPowerstoggle(index); }}>View Powers</div>
                            {data.prescription && <ul className="view-power-lens row-fluid hide">
                                {Object.keys(data.prescription.left !== undefined && data.prescription.left).map((keyName, valueName) => {
                                    if (data.prescription.left[keyName] !== '') {
                                        return (
                                            <li className="Lens-Package" key={valueName}>
                                                <strong className="f12">Left {keyName}
                                                </strong>
                                                {' '}
                                                <span>{data.prescription.left[keyName]}</span>
                                            </li>
                                        );
                                    }
                                    return ('');
                                })}
                                {Object.keys(data.prescription.right !== undefined && data.prescription.right).map((keyName, valueName) => {
                                    if (data.prescription.right[keyName] !== '') {
                                        return (
                                            <li className="Lens-Package" key={valueName}>
                                                <strong className="f12">Right {keyName}
                                                </strong>
                                                {' '}
                                                <span>{data.prescription.right[keyName]}</span>
                                            </li>
                                        );
                                    }
                                    return ('');
                                })}
                            </ul>}
                        </div>
                    )
                }
                {
                    data.options.length > 0 && (
                        <div>
                            <div className="pull-left pls-crt-sign">+</div>
                            <div className="crt-lns-prce">
                                <div className="text-center">
                                    LENS PACKAGE
                                        {' '}
                                </div>
                                <table className="lns-detail-tab">
                                    {
                                        data.options.map((optData, index) => {
                                            return (
                                                <tbody key={index}>
                                                    {(optData.type === 'COATING' && index === 1) ? (
                                                        <tr className="Lens-Package futura-h">
                                                            <td>
                                                                <strong className="f12"> Add On</strong>
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                    <tr key={index} className="Lens-Package">
                                                        <td>
                                                            <strong className="f12">{optData.type === 'COATING' ? `-${optData.name}` : optData.name}
                                                            </strong>
                                                        </td>
                                                        {optData.catalogPrices[0].value !== optData.catalogPrices[1].value && (
                                                            <td className="old-price packges-block">
                                                                {' '}
                                                                <i className="fa fa-rupee"></i>{optData.catalogPrices[0].value}
                                                            </td>
                                                        )}
                                                        <td className="packges-block">
                                                            {' '}
                                                            <i className="fa fa-rupee"></i>{optData.catalogPrices[1].value}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            );
                                        })
                                    }
                                </table>
                            </div>
                        </div>
                    )
                }
                <div className="pull-right">
                    <div className="col-lg-4">
                        <div className="pull-left margin-t10 fs24">=</div>
                    </div>
                    <div className="col-lg-8">
                        <div>SUBTOTAL</div>
                        <div className="margin-t0 f14">
                        <i className="fa fa-rupee"></i>{data.price.value * data.quantity}
                        </div>
                    </div>
                </div>
                <div className="row-fluid cart-item_amount_status">
                    <span> Selling fast! Few pieces left !</span>
                </div>
            </div>
            {
                data.availableQuantity === 1
                && (
                    <div className="cart-item_message">
                        <span>
                            <i className="fa fa-2x fa-bullhorn" aria-hidden="true"></i>
                            <span className="oos-text"> Only 1 quantity left, Hurry !!! </span>
                        </span>
                    </div>
                )
            }
        </div>
    );
};


export default CartItem;
